export default (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" color={'inherit'} xmlns="http://www.w3.org/2000/svg">
    <path d="M20 12L4 12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
